export const SET_STRUCTURES = 'SET_STRUCTURES'
export const ADD_STRUCTURE = 'ADD_STRUCTURE'
export const UPDATE_STRUCTURE = 'UPDATE_STRUCTURE'
export const DELETE_STRUCTURE = 'DELETE_STRUCTURE'